import { shopPrefix } from '../../config';
import { AggregationResponseOut } from '../../store/api';
import { ProductFilter } from '../../../models/Product';
import { http } from '../axios';
import { AgeCategory } from '../../../models/AgeCategory';

type Options = {
    readonly signal?: AbortSignal;
    readonly loanFormat: string;
    readonly ageCategory?: string;
    readonly filters?: ProductFilter;
    readonly shopLanguage: string | undefined;
};

const url = `${shopPrefix}/v2/standard/allproducts/:loanFormat/aggregation`;

export const fetchAllProductsAggregations = (options: Options) => {
    return http
        .post<AggregationResponseOut>(url, options.filters, {
            pathParams: { loanFormat: options.loanFormat },
            params: {
                ageCategory: options.ageCategory === AgeCategory.ALL_AGES ? undefined : options.ageCategory,
                shopLanguage: options.shopLanguage
            },
            signal: options.signal
        })
        .then(res => res.data);
};
